import {createContext, useContext, useMemo} from 'react';
import {
  createParentMessageBus,
  ParentMessageBus,
  ParentMessageListenerFn,
} from '../../helpers/parentMessageBus';
import {MessageToParent} from './MessageToParent';
import {ConfigContext} from '../ConfigProvider';

// Default message bus should never end up being used but we need something so
// that our context doesn't have to be defined as returning potentially
// undefined or null. So all these methods will throw to ensure we don't
// silently fail somehow.
const defaultMessageBus: ParentMessageBus = {
  post(_message: MessageToParent): void {
    throw new Error('Function not implemented.');
  },
  requestAnalyticsEventId(): Promise<string | null> {
    throw new Error('Function not implemented.');
  },
  addListener(_listener: ParentMessageListenerFn): void {
    throw new Error('Function not implemented.');
  },
  removeListener(_listener: ParentMessageListenerFn): void {
    throw new Error('Function not implemented.');
  },
};

export const ParentMessageBusContext =
  createContext<ParentMessageBus>(defaultMessageBus);

export function ParentMessageBusProvider({children}: {children: JSX.Element}) {
  const {
    audience,
    entrypoint: entryPoint,
    parentOrigin,
  } = useContext(ConfigContext);
  const parentMessageBus = useMemo(
    () => createParentMessageBus({audience, entryPoint, parentOrigin}),
    [audience, entryPoint, parentOrigin],
  );
  return (
    <ParentMessageBusContext.Provider value={parentMessageBus}>
      {children}
    </ParentMessageBusContext.Provider>
  );
}
